import './MapSection.css'

function MapSection() {
  return (
    <div className="map-section">
      <iframe
  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15723.953919510977!2d76.9370079!3d11.031221!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTHCsDAzJzEyLjQiTiA3NsKwNTYnMTMuMiJF!5e0!3m2!1sen!2sin!4v1733220000000"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  title="New Location"
/>

    </div>
  )
}

export default MapSection
